import React from 'react';
import clsx from 'clsx';
import { TooltipPropsWithTitle } from 'antd/lib/tooltip';
import { Tooltip as AntdTooltip } from 'antd';
import './style.less';

/**
 * Common Tooltip with cusomizations used in SB.
 * - wraps antd Tooltip
 */

type TooltipProps = TooltipPropsWithTitle &
  React.RefAttributes<unknown> & {
    theme: 'dark' | 'light';
  };

export const Tooltip: React.FC<TooltipProps> = ({
  theme,
  children,
  overlayClassName,
  ...rest
}) => {
  const className = clsx('Tooltip', `Tooltip--${theme}`, overlayClassName);
  return (
    <AntdTooltip overlayClassName={className} {...rest}>
      {children}
    </AntdTooltip>
  );
};
